import { createClient } from '@supabase/supabase-js'
import { appConfig } from '@/config/environment'

/**
 * The application owns this key, so it can also remove what is stored under it.
 */
export const supabaseAuthStorageKey = `${appConfig.storageNamespace}:auth`

export const supabase = createClient(
  appConfig.supabaseUrl,
  appConfig.supabasePublishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: supabaseAuthStorageKey,
    },
  },
)

/**
 * Ends the persisted session on this device without asking the server.
 *
 * supabase-js only removes the stored session once the server has accepted the
 * sign-out, so when that request fails — offline, or a backend outage — the
 * access and refresh tokens stay in storage and a later reload restores a fully
 * authenticated session on a device the user believes they have signed out of.
 * Removing the key is the same operation the client performs itself when
 * sign-out succeeds, and it is the part that matters on a shared device.
 */
export function clearPersistedSession(): void {
  try {
    window.localStorage.removeItem(supabaseAuthStorageKey)
  } catch {
    // Storage is unavailable; there is nothing persisted to clear.
  }
}
